export default __webpack_public_path__ + "static/media/Flag_of_Japan.1ca5a40c.svg";